
    import _Handlebars from 'handlebars/runtime';

    var Handlebars = _Handlebars.default;
    import "@canvas/i18n";
import "@canvas/handlebars-helpers/index.js";

    var template = Handlebars.template, templates = Handlebars.templates = Handlebars.templates || {};
    var name = '/var/canvas/ui/features/submit-assignment/jst/ExternalContentHomeworkFileSubmissionView';
    templates[name] = template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", stack1, helper, options, functionType="function", escapeExpression=this.escapeExpression, self=this, helperMissing=helpers.helperMissing;

function program1(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n          <div class=\"turnitin_pledge_container_external_homework_file\"\n               data-eulaurl=\""
    + escapeExpression(((stack1 = ((stack1 = (depth0 && depth0.ENV)),stack1 == null || stack1 === false ? stack1 : stack1.EULA_URL)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "\"\n               style=\"margin:0px 0px 10px 0px\">\n          </div>\n        ";
  return buffer;
  }

function program3(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n          ";
  stack1 = helpers['if'].call(depth0, ((stack1 = (depth0 && depth0.ENV)),stack1 == null || stack1 === false ? stack1 : stack1.SIMILARITY_PLEDGE), {hash:{},inverse:self.noop,fn:self.program(4, program4, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n        ";
  return buffer;
  }
function program4(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n            <div class=\"turnitin_pledge_container_external_homework_file\"\n                 data-pledge=\""
    + escapeExpression(((stack1 = ((stack1 = (depth0 && depth0.ENV)),stack1 == null || stack1 === false ? stack1 : stack1.SIMILARITY_PLEDGE)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "\"\n                 style=\"margin:0px 0px 10px 0px\">\n            </div>\n          ";
  return buffer;
  }

  buffer += "<div style=\"padding: 20px;\">\n  <form class=\"form-horizontal external-tool-submission\" role=\"form\">\n\n    <div class=\"control-group\">\n      <label class=\"control-label\">File</label>\n      <div class=\"controls\" style=\"padding-top: 5px;\">\n        <strong>";
  if (helper = helpers.text) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.text); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "</strong>\n        <a href=\"#\" class=\"relaunch-tool btn btn-mini\">change</a>\n      </div>\n    </div>\n\n    <div class=\"control-group\">\n      <label class=\"control-label\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("assignments.external_content_homework_file_submission_view")
  },data:data},helper ? helper.call(depth0, "assignments.external_content_homework_file_submission_view.additional_comments", "Additional comments", options) : helperMissing.call(depth0, "t", "assignments.external_content_homework_file_submission_view.additional_comments", "Additional comments", options)))
    + "</label>\n      <div class=\"controls\">\n        <textarea class=\"submission_comment\" rows=\"3\" placeholder=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("assignments.external_content_homework_file_submission_view")
  },data:data},helper ? helper.call(depth0, "assignments.external_content_homework_file_submission_view.group_assignment_header", "Comments...", options) : helperMissing.call(depth0, "t", "assignments.external_content_homework_file_submission_view.group_assignment_header", "Comments...", options)))
    + "\" title=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("assignments.external_content_homework_file_submission_view")
  },data:data},helper ? helper.call(depth0, "assignments.external_content_homework_file_submission_view.additional_comments", "Additional comments", options) : helperMissing.call(depth0, "t", "assignments.external_content_homework_file_submission_view.additional_comments", "Additional comments", options)))
    + "\"></textarea>\n      </div>\n    </div>\n\n    <div class=\"control-group\">\n      <div class=\"controls\">\n        ";
  stack1 = helpers['if'].call(depth0, ((stack1 = (depth0 && depth0.ENV)),stack1 == null || stack1 === false ? stack1 : stack1.EULA_URL), {hash:{},inverse:self.program(3, program3, data),fn:self.program(1, program1, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n        <button type=\"button\" class=\"cancel_button btn\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("buttons"),
    'i18n_used_in': ("assignments.external_content_homework_file_submission_view")
  },data:data},helper ? helper.call(depth0, "buttons.cancel", "Cancel", options) : helperMissing.call(depth0, "t", "buttons.cancel", "Cancel", options)))
    + "</button>\n        <button type=\"submit\" class=\"submit_button btn btn-primary\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("assignments.external_content_homework_file_submission_view")
  },data:data},helper ? helper.call(depth0, "assignments.external_content_homework_file_submission_view.buttons.submit_assignment", "Submit Assignment", options) : helperMissing.call(depth0, "t", "assignments.external_content_homework_file_submission_view.buttons.submit_assignment", "Submit Assignment", options)))
    + "</button>\n      </div>\n    </div>\n\n  </form>\n</div>\n";
  return buffer;
  });
    ;
    ;
    export default templates[name];
  